import React from 'react';
import { Caption, Table, Tbody, Td, Th, Thead, Tr } from '@patternfly/react-table';
import { Skeleton } from '@patternfly/react-core';
function hasCustomColumns(props) {
    return Array.isArray(props.columns);
}
const SkeletonTable = (props) => {
    const { variant, rows = 5, caption } = props;
    const rowCells = hasCustomColumns(props) ? props.columns.length : props.numberOfColumns;
    const rowArray = [...new Array(rowCells)];
    const bodyRows = [...new Array(rows)].map((_, index) => (React.createElement(Tr, { key: index }, rowArray.map((_, index) => (React.createElement(Td, { key: index },
        React.createElement(Skeleton, null)))))));
    return (React.createElement(Table, { "aria-label": "Loading", variant: variant },
        caption && React.createElement(Caption, null, caption),
        React.createElement(Thead, null,
            React.createElement(Tr, null, hasCustomColumns(props)
                ? props.columns.map((c, index) => React.createElement(Th, { key: index }, c))
                : rowArray.map((_, index) => (React.createElement(Th, { key: index },
                    React.createElement(Skeleton, null)))))),
        React.createElement(Tbody, null, bodyRows)));
};
export default SkeletonTable;
